import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'
import { Link } from 'react-router-dom'

export type ProductListingCardActionType = 'Link' | 'Action'

const useStyles = makeStyles((theme: Theme) => ({
    actionContainer: { cursor: 'pointer' },
}))

interface ProductListingCardActionProps {
    type: ProductListingCardActionType
    /**
     * If Action this is required
     */
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
    /**
     * If Link this is required
     */
    to?: string
    /**
     * If link target
     */
    target?: string
    /**
     * Add className for Link component
     */
    linkClassName?: string
    /**
     * Add className for Action component
     */
    actionClassName?: string
    /**
     * If link is unselectable
     */
    unselectable?: 'on' | 'off'
}

export const ProductListingCardAction: React.FC<ProductListingCardActionProps> = ({
    type,
    onClick,
    to,
    target,
    unselectable,
    linkClassName,
    actionClassName,
    children,
}) => {
    const classes = useStyles()
    if (type === 'Link' && !to) return null
    return (
        <>
            {!!to && type === 'Link' && (
                <Link
                    unselectable={unselectable}
                    target={target}
                    to={to}
                    className={clsx('cardLink', linkClassName)}
                >
                    {children}
                </Link>
            )}
            {type === 'Action' && (
                <div
                    className={clsx(
                        'cardFuntion',
                        !!onClick && classes.actionContainer,
                        actionClassName
                    )}
                    onClick={!!onClick ? onClick : undefined}
                >
                    {children}
                </div>
            )}
        </>
    )
}
